/*!
 * devextreme-angular
 * Version: 24.2.5
 * Build date: Fri Feb 14 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    OnInit,
    OnDestroy,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';





import {
    NestedOptionHost,
} from 'devextreme-angular/core';
import { NestedOption } from 'devextreme-angular/core';


@Component({
    selector: 'dxo-tree-list-editing-texts',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxoTreeListEditingTextsComponent extends NestedOption implements OnDestroy, OnInit  {
    @Input()
    get addRow(): string {
        return this._getOption('addRow');
    }
    set addRow(value: string) {
        this._setOption('addRow', value);
    }

    @Input()
    get addRowToNode(): string {
        return this._getOption('addRowToNode');
    }
    set addRowToNode(value: string) {
        this._setOption('addRowToNode', value);
    }

    @Input()
    get cancelAllChanges(): string {
        return this._getOption('cancelAllChanges');
    }
    set cancelAllChanges(value: string) {
        this._setOption('cancelAllChanges', value);
    }

    @Input()
    get cancelRowChanges(): string {
        return this._getOption('cancelRowChanges');
    }
    set cancelRowChanges(value: string) {
        this._setOption('cancelRowChanges', value);
    }

    @Input()
    get confirmDeleteMessage(): string {
        return this._getOption('confirmDeleteMessage');
    }
    set confirmDeleteMessage(value: string) {
        this._setOption('confirmDeleteMessage', value);
    }

    @Input()
    get confirmDeleteTitle(): string {
        return this._getOption('confirmDeleteTitle');
    }
    set confirmDeleteTitle(value: string) {
        this._setOption('confirmDeleteTitle', value);
    }

    @Input()
    get deleteRow(): string {
        return this._getOption('deleteRow');
    }
    set deleteRow(value: string) {
        this._setOption('deleteRow', value);
    }

    @Input()
    get editRow(): string {
        return this._getOption('editRow');
    }
    set editRow(value: string) {
        this._setOption('editRow', value);
    }

    @Input()
    get saveAllChanges(): string {
        return this._getOption('saveAllChanges');
    }
    set saveAllChanges(value: string) {
        this._setOption('saveAllChanges', value);
    }

    @Input()
    get saveRowChanges(): string {
        return this._getOption('saveRowChanges');
    }
    set saveRowChanges(value: string) {
        this._setOption('saveRowChanges', value);
    }

    @Input()
    get undeleteRow(): string {
        return this._getOption('undeleteRow');
    }
    set undeleteRow(value: string) {
        this._setOption('undeleteRow', value);
    }

    @Input()
    get validationCancelChanges(): string {
        return this._getOption('validationCancelChanges');
    }
    set validationCancelChanges(value: string) {
        this._setOption('validationCancelChanges', value);
    }


    protected get _optionPath() {
        return 'texts';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }


    ngOnInit() {
        this._addRecreatedComponent();
    }

    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }


}

@NgModule({
  declarations: [
    DxoTreeListEditingTextsComponent
  ],
  exports: [
    DxoTreeListEditingTextsComponent
  ],
})
export class DxoTreeListEditingTextsModule { }
